import { useState, useCallback } from 'react';


const useMutation = (setter) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState();
  const [error, setError] = useState();

  const wrappedSetter = useCallback(
    async (args, onSuccess, onError) => {
      setLoading(true);
      const response = await setter(args);
      if (response.status === 200) {
        setResponse(response);
        onSuccess && onSuccess();
      } else {
        setError(response);
        onError && onError();
      }
      setLoading(false);
    },
    [setter]
  )

  return { loading, response, error, setter: wrappedSetter }
}

export default useMutation;
